if (!customElements.get('yalorde-stock-packs')) {
  customElements.define('yalorde-stock-packs', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.root.addEventListener('input', () => this.sync(), options);
      this.root.addEventListener('change', () => this.sync(), options);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-qty]');
        if (!button || button.disabled) return;
        const input = this.root.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.qty;
        this.sync();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, options);
      this.root.addEventListener('submit', (event) => {
        this.sync();
        const input = this.root.querySelector('input[name="quantity"]');
        if (input && (Number(input.max) === 0 && input.hasAttribute('max') || !input.checkValidity())) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      const root = this.root || this.closest('product-info');
      const input = root?.querySelector('input[name="quantity"]');
      if (!input) return;
      const limit = input.hasAttribute('max') ? Number(input.max) : Infinity;
      const minimum = Math.max(1, Number(input.dataset.min) || 1);
      const step = Number(input.step) || 1;
      const value = Math.max(minimum, Math.trunc(Number(input.value) || minimum));
      const clamped = limit < minimum ? 0 : Math.min(value, limit === Infinity ? value : minimum + Math.floor((limit - minimum) / step) * step);
      input.value = String(clamped);
      input.disabled = limit < minimum;
      this.querySelectorAll('[data-qty]').forEach((button) => {
        const quantity = Number(button.dataset.qty);
        button.disabled = quantity > limit || quantity < minimum || (quantity - minimum) % step !== 0;
        const active = !button.disabled && quantity === clamped;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const control = input.closest('quantity-input');
      const plus = control?.querySelector('[name="plus"]');
      const minus = control?.querySelector('[name="minus"]');
      if (plus) plus.disabled = clamped + step > limit;
      if (minus) minus.disabled = clamped <= minimum;
      const submit = root.querySelector('button[name="add"]');
      if (submit && limit < minimum) {
        submit.disabled = true;
        submit.dataset.stockBlocked = 'true';
      } else if (submit?.dataset.stockBlocked) {
        submit.disabled = false;
        delete submit.dataset.stockBlocked;
      }
      const payment = root.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = limit < minimum;
    }
  });
}
